export const socialNotifications = {
  socialNotifTitle: "活动",
  socialNotifMarkAll: "全部标记为已读",
  socialNotifEmpty: "暂无活动",
  socialNotifEmptyDesc: "有新活动时，您将在此处看到",
  socialNotifJustNow: "刚刚",
  socialNotifMinAgo: "{{count}}分钟前",
  socialNotifHrsAgo: "{{count}}小时前",
  socialNotifDaysAgo: "{{count}}天前",
  socialNotifWeeksAgo: "{{count}}周前",
  socialNotifFollowers: "关注者",
  socialNotifPrizes: "奖品",
  socialNotifNewGames: "新游戏",
  socialNotifPromos: "促销",
  socialNotifTournaments: "锦标赛",
  socialNotifComments: "评论",
};
